import { useGetProviderIconUrl } from '../../hooks/use-get-provider-icon-url'
import { BaseProviderIcon } from '../../provider-icons/base-provider-icon'

interface IProviderIconProps {
  size?: number
}

/**
 * The FourKites icon component using SVG and Tailwind CSS
 */
export const FourKitesIcon = ({ size }: IProviderIconProps) => {
  const iconUrl = useGetProviderIconUrl('fourkites-logo', 'logo')
  return <BaseProviderIcon size={size} src={iconUrl} label="fourkites-icon" />
}
